module.exports = __webpack_public_path__ + "static/front-007-c86924cadc62791d0e0b4a4661aa72ea.png";